import { TStoreMain } from "./reducer";

export const getStatusAsync = (state: TStoreMain) => state.statusAsync;
